import { render, staticRenderFns } from "./SupBreadcrumb.vue?vue&type=template&id=38d64876&"
import script from "./SupBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./SupBreadcrumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SupBreadcrumb.vue"
export default component.exports